import React from "react";

// empty
import EmptyPage from "pages/Empty";

// auth
import AuthLayout from "layouts/Auth";
import LoginPage from "pages/auth/Login";
import LoginOtpPage from "pages/auth/LoginOtp";
import ResetPage from "pages/auth/Reset";
import OtpPage from "pages/auth/Otp";

// app
import DefaultLayout from "layouts/Default";
import AboutPage from "pages/default/AboutUs";
import BannersPage from "pages/default/Banners";
import CategoriesPage from "pages/default/Categories";
import ContactPage from "pages/default/ContactUs";
import CouponsPage from "pages/default/Coupons";
import CoursesPage from "pages/default/Courses";
import DashboardPage from "pages/default/Dashboard";
import FaqPage from "pages/default/FAQ";
import FilesPage from "pages/default/Files";
import GalleryPage from "pages/default/Gallery";
import NotificationPage from "pages/default/Notification";
import PackagePage from "pages/default/Package";
import PlatformPage from "pages/default/Platform";
import RolesPage from "pages/default/Roles";
import SamplesPage from "pages/default/Samples";
import SettingPage from "pages/default/Setting";
import TacPage from "pages/default/TAC";
import TransactionsPage from "pages/default/Transactions";
import VideosPage from "pages/default/Videos";
import VersionPage from "pages/default/Version";
import UsersPage from "pages/default/Users";
import SoundPage from "pages/default/Sound";
// sort
import SortCoursesPage from "pages/default/sort/Courses";
import SortFAQPage from "pages/default/sort/FAQ";
import SortSessionsPage from "pages/default/sort/Sessions";

// errors
import NotFoundPage from "pages/result/NotFound";
import UnAuthorizedPage from "pages/result/UnAuthorized";

import { Permissions } from "scripts/settings";
import Resources from "scripts/resources";

export default [
	// errors
	{
		path: "/403",
		name: "unauthorized",
		component: UnAuthorizedPage,
	},
	{
		path: "/404",
		name: "notfound",
		component: NotFoundPage,
	},
	// authorization
	{
		path: "/auth",
		name: "auth",
		component: AuthLayout,
		routes: [
			{
				path: "/auth",
				name: "loginRedirect",
				redirect: "/auth/login",
			},
			{
				path: "/auth/login",
				name: "login",
				title: Resources.login,
				component: LoginPage,
			},
			{
				path: "/auth/reset",
				name: "reset",
				title: Resources.passwordRecovery,
				component: ResetPage,
			},
			{
				path: "/auth/get-otp",
				name: "getOtp",
				title: Resources.getOtp,
				component: OtpPage,
			},
			{
				path: "/auth/login-otp",
				name: "getOtp",
				title: Resources.login,
				component: LoginOtpPage,
			},
		],
	},
	// app
	{
		path: "/",
		name: "app",
		component: DefaultLayout,
		routes: [
			{
				name: "loginRedirect",
				path: "/login",
				redirect: "/auth/login",
			},
			{
				name: "dashboardRedirect",
				path: "/",
				redirect: "/dashboard",
			},
			{
				name: "dashboard",
				icon: <i className="ant-menu-item-icon fa fa-laptop" />,
				path: "/dashboard",
				title: Resources.dashboard,
				component: DashboardPage,
			},
			{
				name: "userManagement",
				icon: <i className="ant-menu-item-icon fa fa-users" />,
				title: Resources.users,
				routes: [
					{
						name: "users",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/users",
						title: Resources.users,
						component: UsersPage,
						authority: Permissions.USER_VIEW,
					},
					{
						name: "roles",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/roles",
						title: Resources.roles,
						component: RolesPage,
						authority: Permissions.ROLE_VIEW,
					},
				],
			},
			{
				name: "courceManagement",
				icon: <i className="ant-menu-item-icon fa fa-chalkboard-teacher" />,
				title: `${Resources.training}${Resources.ha}`,
				routes: [
					{
						name: "courses",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/courses",
						title: `${Resources.course}${Resources.ha}`,
						component: CoursesPage,
						authority: Permissions.COURSE_VIEW,
					},
					{
						name: "packages",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/packages",
						title: `${Resources.package}${Resources.ha}`,
						component: PackagePage,
						authority: Permissions.PACKAGE_VIEW,
					},
					{
						name: "categories",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/categories",
						title: `${Resources.category}${Resources.ha}`,
						component: CategoriesPage,
						authority: Permissions.CATEGORY_VIEW,
					},
					{
						name: "gallery",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/gallery",
						title: `${Resources.image}${Resources.ha}`,
						component: GalleryPage,
					},
					{
						name: "videos",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/videos",
						title: `${Resources.video}${Resources.ha}`,
						component: VideosPage,
						authority: Permissions.SESSION_VIDEO_VIEW,
					},
					{
						name: "files",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/files",
						title: `${Resources.file}${Resources.ha}`,
						component: FilesPage,
						authority: Permissions.FILES_VIEW,
					},

					{
						name: "sounds",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/sounds",
						title: `${Resources.soundFile}`,
						component: SoundPage,
						authority: Permissions.SOUND_VIEW,
					},
					{
						name: "discounts",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/discounts",
						title: `${Resources.discount}${Resources.ha}`,
						component: CouponsPage,
						authority: Permissions.COUPON_VIEW,
					},
				],
			},
			{
				name: "pageManagement",
				icon: <i className="ant-menu-item-icon fa fa-globe" />,
				title: Resources.pages,
				routes: [
					{
						name: "about",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/about",
						title: Resources.aboutTeacher,
						component: AboutPage,
						authority: Permissions.ABOUT_VIEW,
					},
					{
						name: "contact",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/contact",
						title: Resources.contactUs,
						component: ContactPage,
						authority: Permissions.CONTACT_VIEW,
					},
					{
						name: "tac",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/tac",
						title: Resources.aboutCourse,
						component: TacPage,
						authority: Permissions.TAC_VIEW,
					},
					{
						name: "faq",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/faq",
						title: Resources.faq,
						component: FaqPage,
						authority: Permissions.FAQ_VIEW,
					},
				],
			},
			{
				name: "financial",
				icon: <i className="ant-menu-item-icon fa fa-credit-card" />,
				title: Resources.financial,
				routes: [
					{
						name: "transactions",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/transactions",
						title: `${Resources.transaction}${Resources.ha}`,
						component: TransactionsPage,
						authority: Permissions.TRANSACTION_VIEW,
					},
				],
			},
			{
				name: "publicManagement",
				icon: <i className="ant-menu-item-icon fa fa-cogs" />,
				title: Resources.public,
				routes: [
					{
						name: "banners",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/banners",
						title: `${Resources.banner}${Resources.ha}`,
						component: BannersPage,
						authority: Permissions.BANNER_VIEW,
					},
					// {
					// 	name: "samples",
					// 	icon: <i className="ant-menu-item-icon fa fa-folder" />,
					// 	path: "/samples",
					// 	title: `${Resources.sample}${Resources.ha}`,
					// 	component: SamplesPage,
					// 	authority: Permissions.SAMPLE_VIEW,
					// },
					{
						name: "notification",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/notification",
						title: Resources.notifications,
						component: NotificationPage,
						authority: Permissions.NOTIFICATION_VIEW,
					},
					{
						name: "platform",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/platform",
						title: Resources.platform,
						component: PlatformPage,
						authority: Permissions.PLATFORM_VIEW,
					},
					{
						name: "setting",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/setting",
						title: `${Resources.settings}`,
						component: SettingPage,
						// authority: Permissions.SETTING_UPDATE,
					},

					{
						name: "version",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/version",
						title: Resources.version,
						component: VersionPage,
						authority: Permissions.VERSION_VIEW,
					},
				],
			},
			{
				name: "sortManagement",
				icon: <i className="ant-menu-item-icon fa fa-sort" />,
				title: Resources.sort,
				routes: [
					{
						name: "sortCourses",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/sort/courses",
						title: `${Resources.course}${Resources.ha}`,
						component: SortCoursesPage,
						authority: Permissions.COURSE_VIEW,
					},
					{
						name: "sortSessions",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/sort/sessions",
						title: Resources.sessions,
						component: SortSessionsPage,
						authority: Permissions.SESSION_VIEW,
					},
					{
						name: "sortFAQ",
						icon: <i className="ant-menu-item-icon fa fa-folder" />,
						path: "/sort/faq",
						title: Resources.faq,
						component: SortFAQPage,
						authority: Permissions.FAQ_VIEW,
					},
				],
			},
		],
	},
];
